/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/styles';
import GenericSkeleton from '../GraphqlSkeletonComponents/GenericSkeleton';
import HeaderGenericLoader from './Partials/HeaderGenericLoader';

const useStyles = makeStyles({
    containr: {
        maxWidth: '1300px',
        margin: '0 auto',
    },
    prodcutContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        '&>div': {
            width: '98vw',
            minWidth: '280px',
            maxWidth: '410px',
            margin: '0 auto !important',
        },
        '&>div:nth-child(1)': {
            '@media screen and (max-width: 768px)': {
                display: 'none',
            },
        },
        '&>div:nth-child(2)': {
            '@media screen and (max-width: 768px)': {
                display: 'none',
            },
        },
        '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
        },
    },
});

const SubscriptionGenericLoader = () => {
    const classes = useStyles();
    return (
        <div className={classes.containr}>
            <HeaderGenericLoader />
            <div className={classes.prodcutContainer}>
                <GenericSkeleton height="450px" width="100%" />
                <GenericSkeleton height="450px" width="100%" />
                <GenericSkeleton height="450px" width="100%" />
            </div>
        </div>
    );
};

export default SubscriptionGenericLoader;
